var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-dialog',{staticClass:"user-dialog",attrs:{"visible":_vm.visible,"width":"854px","title":_vm.editorTitle},on:{"update:visible":function($event){_vm.visible=$event},"submit":_vm.handleSubmit}},[_c('base-form',{ref:"formData",staticClass:"formStyle",attrs:{"componentList":_vm.componentList,"formAttrs":{
      model: _vm.formData,
      labelWidth: '140px',
    },"showBtns":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }